import { RouterProvider } from "react-router-dom";
import { AppProviders } from "./AppProviders";
import { adminRouter } from "./router";

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={adminRouter} />
    </AppProviders>
  );
}
